import React from 'react'
import { useRoutes,Navigate } from 'react-router-dom'
import { RouteObject } from '../interface'
import Login from '../views/login'
import Home from '../views/home'
import Layout from '../layout'
export const rootRouters: RouteObject[] = [
    {
        element: <Layout />,
        children:[{
            path: '/',
            element: <Home />,
            meta: {
                requiresAuth: true,
                title: '首页',
                key: 'Home'
            },
        }]
    },
    {
        path: '/login',
        element: <Login />,
        meta: {
            requiresAuth: false,
            title: '登录页',
            key: 'login'
        }
    },
    {
        path: '*',
        element: <Navigate to="/" />
    }
]

const Router = () => {
    const routes = useRoutes(rootRouters)
    return routes
}

export default Router